export function calculatePrice(orderId: string) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/orders/${orderId}/calculate-price`,
  }
}

export function getOrderServiceById(orderObjectId: string | undefined) {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/order_service/${orderObjectId}`,
  }
}
